export const ocazii_si_evenimente_column1 = [
    {
        id: "1",
        path: "/Ocazii-si-evenimente/Flori-Onomastica",
        name: "Flori Onomastica",
        cName: "nav-dropdown"
    },
    {
        id: "2",
        path: "/Ocazii-si-evenimente/Buchete-La-Multi-Ani",
        name: "Buchete La Multi Ani",
        cName: "nav-dropdown"
    },
    {
        id: "3",
        path: "/Ocazii-si-evenimente/Ocazii-speciale",
        name: "Ocazii speciale",
        cName: "nav-dropdown"
    },
    {
        id: "4",
        path: "/Ocazii-si-evenimente/Coroane-funerare",
        name: "Coroane funerare",
        cName: "nav-dropdown"
    },
    {
        id: "5",
        path: "/Ocazii-si-evenimente/Flori-pentru-nunta",
        name: "Flori pentru nunta",
        cName: "nav-dropdown"
    },
    {
        id: "6",
        path: "/Ocazii-si-evenimente/Flori-Halloween",
        name: "Flori Halloween",
        cName: "nav-dropdown"
    },
    {
        id: "7",
        path: "/Ocazii-si-evenimente/Flori-Sfantul-Andrei",
        name: "Flori Sfantul Andrei",
        cName: "nav-dropdown"
    },
    {
        id: "8",
        path: "/Ocazii-si-evenimente/Flori-Sfantul-Stefan",
        name: "Flori Sfantul Stefan",
        cName: "nav-dropdown"
    },

]

export const ocazii_si_evenimente_column2 = [
    {
        id: "9",
        path: "/Ocazii-si-evenimente/Flori-Constantin-si-Elena",
        name: "Flori Constantin si Elena",
        cName: "nav-dropdown"
    },
    {
        id: "10",
        path: "/Ocazii-si-evenimente/Flori-Sfantul-Nicolae",
        name: "Flori Sfantul Nicolae",
        cName: "nav-dropdown"
    },
    {
        id: "11",
        path: "/Ocazii-si-evenimente/Flori-Sfantul-Ioan",
        name: "Flori Sfantul Ioan",
        cName: "nav-dropdown"
    },
    {
        id: "12",
        path: "/Ocazii-si-evenimente/Flori-Sfanta-Maria",
        name: "Flori Sfanta Maria",
        cName: "nav-dropdown"
    },
    {
        id: "13",
        path: "/Ocazii-si-evenimente/Flori-Sfantul-Gheorghe",
        name: "Flori Sfantul Gheorghe",
        cName: "nav-dropdown"
    },
    {
        id: "14",
        path: "/Ocazii-si-evenimente/Flori-Sfantul-Alexandru",
        name: "Flori Sfantul Alexandru",
        cName: "nav-dropdown"
    },
    {
        id: "15",
        path: "/Ocazii-si-evenimente/Flori-Sfanta-Ana",
        name: "Flori Sfanta Ana",
        cName: "nav-dropdown"
    },
    {
        id: "16",
        path: "/Ocazii-si-evenimente/Flori-Sfantul-Dumitru",
        name: "Flori Sfantul Dumitru",
        cName: "nav-dropdown"
    },
]

export const ocazii_si_evenimente_column3 = [
    {
        id: "17",
        path: "/Ocazii-si-evenimente/Flori-Florii",
        name: "Flori Florii",
        cName: "nav-dropdown"
    },
    {
        id: "18",
        path: "/Ocazii-si-evenimente/Sfintii-Mihail-si-Gavril",
        name: "Sfintii Mihail si Gavril",
        cName: "nav-dropdown"
    },
    {
        id: "19",
        path: "/Ocazii-si-evenimente/Flori-8-Martie",
        name: "Flori 8 Martie",
        cName: "nav-dropdown"
    },
    {
        id: "20",
        path: "/Ocazii-si-evenimente/Flori-1-Martie",
        name: "Flori 1 Martie",
        cName: "nav-dropdown"
    },
    {
        id: "21",
        path: "/Flori-Valentines-Day",
        name: "Flori Valentines Day",
        cName: "nav-dropdown"
    },
    {
        id: "22",
        path: "/Ocazii-si-evenimente/Aranjamente-&-Brazi-de-Craciun",
        name: "Aranjamente & Brazi de Craciun",
        cName: "nav-dropdown"
    },
    {
        id: "23",
        path: "/Ocazii-si-evenimente/Flori-de-Dragobete",
        name: "Flori de Dragobete",
        cName: "nav-dropdown"
    },
]